import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

type AnnotationProps = {
    bgColor?: string;
    textColor?: string;
    borderTopColor?: string;
    boxStyle?: Record<string, string | number>;
    product?: string;
};

export default function Annotation({ bgColor, textColor, borderTopColor = '#444', product = '' }: AnnotationProps) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();

    const textI18N: any = {
        cn: `本页中，出现的“${product ? `${product}、` : ''}DELTA、RIVER”均为ECOFLOW INC.生产的产品`,
        tw: `本頁中，出現的「${product ? `${product}、` : ''}DELTA、RIVER」均為ECOFLOW INC.所生產的產品`,
        en: `The terms ${
            product ? `“${product}” ` : ''
        }“DELTA” and “RIVER” as mentioned on this page refer to products exclusively manufactured by ECOFLOW INC.`,
        fr: `Les termes ${
            product ? `« ${product} » ` : ''
        } « DELTA » et « RIVER » tels que mentionnés sur cette page font référence à des produits exclusivement fabriqués par ECOFLOW INC.`,
        de: `Die Bezeichnungen ${
            product ? `„${product}“ ` : ''
        } „DELTA“ und „RIVER“ auf dieser Seite beziehen sich auf Produkte, die ausschließlich von ECOFLOW INC. hergestellt werden.`,
        it: `I termini ${
            product ? `“${product}” ` : ''
        } “DELTA” e “RIVER” citati in questa pagina si riferiscono a prodotti realizzati esclusivamente da ECOFLOW INC.`,
        es: `Los términos ${
            product ? `“${product}” ` : ''
        } “DELTA” y “RIVER”, que se mencionan en esta página, se refieren a productos fabricados exclusivamente por ECOFLOW INC.`,
        jp: `このページに記載されている ${
            product ? `「${product}」` : ''
        }「DELTA」および「RIVER」の名称は、ECOFLOW INC.により独占的に製造された製品を指します。`,
        kr: `이 페이지에 언급된 ${product ? `"${product}"` : ''} "DELTA" 및 "RIVER" 라는 용어는 ECOFLOW INC.에서 독점적으로 제조한 제품임을 나타냅니다.`,
        cis: `Термины ${
            product ? `«${product}» ` : ''
        } «DELTA» и «RIVER», упомянутые на этой странице, относятся к продуктам, производимым исключительно компанией ECOFLOW INC.`,
        sa: `يشير المصطلحان ${
            product ? `"${product}" ` : ''
        } "DELTA" و"RIVER" كما هما مذكوران في هذه الصفحة إلى منتجين يتم إنتاجهما بشكلٍ حصري من قِبَل شركة ECOFLOW INC.`,
        br: `Os termos ${
            product ? `“${product}” ` : ''
        }“DELTA” e “RIVER” mencionados nesta página referem-se a produtos fabricados exclusivamente pela ECOFLOW INC.`,
        mx: `Los términos ${
            product ? `“${product}” ` : ''
        } “DELTA” y “RIVER”, que se mencionan en esta página, se refieren a productos fabricados exclusivamente por ECOFLOW INC.`,
    };

    return (
        <div className={styles.Annotation}>
            <div className={'footer-annotation'} style={{ backgroundColor: bgColor || '#000' }}>
                <div className="annotation-wrapper" style={{ borderTop: `1px solid ${borderTopColor}` }}>
                    <div className="desc" style={{ color: textColor || '#757575' }}>
                        {textI18N[locale] || textI18N.en}
                    </div>
                </div>
            </div>
        </div>
    );
}
